export const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }

    // data: / blob: já são imagens completas — usar direto, NUNCA montar URL.
    // Mensagens de localização guardam o thumbnail do mapa como data:image base64
    // no body; ao montar `${backend}/public/logos/data:image...` gerava uma URL
    // gigante (dezenas de KB) que estoura o limite de header/URI do nginx HTTP/2
    // -> ERR_CONNECTION_CLOSED, derrubando a conexão multiplexada e TODAS as
    // outras requisições junto (ERR_HTTP2_PROTOCOL_ERROR).
    if (imagePath.startsWith('data:') || imagePath.startsWith('blob:')) {
        return imagePath;
    }

    if (imagePath.startsWith('/assets/')) {
        imagePath = imagePath.replace('/assets/', '');
    }

    const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;

    const finalPath = cleanPath.startsWith('logos/') ? cleanPath : `logos/${cleanPath}`;

    const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
        
    return `${backendUrl}/public/${finalPath}`;
};
